import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, Users, Handshake, Inbox } from "lucide-react";
import { api } from "@/lib/api";

export default function Overview() {
  const [stats, setStats] = useState({ events: 0, team: 0, partners: 0, members: 0, contacts: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/events").catch(() => ({ data: [] })),
      api.get("/team").catch(() => ({ data: [] })),
      api.get("/partners").catch(() => ({ data: [] })),
      api.get("/admin/members").catch(() => ({ data: [] })),
      api.get("/admin/contacts").catch(() => ({ data: [] })),
    ]).then(([e, t, p, m, c]) =>
      setStats({ events: e.data.length, team: t.data.length, partners: p.data.length, members: m.data.length, contacts: c.data.length })
    );
  }, []);

  const cards = [
    { label: "Events", value: stats.events, icon: CalendarDays, to: "/admin/events" },
    { label: "Teamleden", value: stats.team, icon: Users, to: "/admin/team" },
    { label: "Partners", value: stats.partners, icon: Handshake, to: "/admin/partners" },
    { label: "Inzendingen", value: stats.members + stats.contacts, icon: Inbox, to: "/admin/inzendingen" },
  ];

  return (
    <div data-testid="admin-overview">
      <h1 className="font-serif text-4xl text-[#0A3087] mb-2">Overzicht</h1>
      <p className="text-[#0B0B0C]/60 text-sm mb-8">Welkom in het beheerpaneel van ELSA Brussel.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} className="bg-white border border-[#E2E8F0] rounded-lg p-6 hover:shadow-[0_8px_32px_rgba(10,48,135,0.08)] transition-shadow group">
            <div className="flex items-center justify-between mb-6">
              <c.icon size={22} style={{ color: "var(--elsa-blue)" }} />
              <span className="h-8 w-8 rounded-full grid place-items-center text-[#0A3087] group-hover:bg-[#0A3087]/10 transition-colors">→</span>
            </div>
            <p className="font-serif text-5xl text-[#0B0B0C]">{c.value}</p>
            <p className="text-[#0B0B0C]/60 text-sm mt-1">{c.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
